<template>
  <div class="outgoing-detail" v-if="detail != null">
    <Toast />

    <div class="card">
      <h5>
        <b>Detail Mutasi Harga</b>
      </h5>
      <div class="p-grid">
        <div class="p-col p-mb-5">
          <label for="">Tipe</label>
          <div>{{ detail.type }}</div>
        </div>
        <div class="p-col p-mb-5">
          <label for="">Nomor Bon</label>
          <div>{{ detail.doc_number }}</div>
        </div>

        <div class="p-col p-mb-5">
          <label for="">Tanggal Bon</label>
          <div>{{ moment(detail.doc_date).format('DD-MM-YYYY') }}</div>
        </div>

        <div class="p-col-12" style="overflow-x: auto">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Harga</th>
                <th>Diskon</th>
                <th v-for="(item, r) in outlets" :key="r">{{ item.code }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in detail.items" :key="k">
                <td>{{ an_item.item_code }}</td>
                <td>{{ an_item.item_name }}</td>
                <td>{{ an_item.price | currency }}</td>
                <td>{{ an_item.discount }}</td>

                <td v-for="(item, r) in outlets" :key="r">
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 1 &&
                      item.id === an_item.warehouse_outbounds[0].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[0].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 2 &&
                      item.id === an_item.warehouse_outbounds[1].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[1].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 3 &&
                      item.id === an_item.warehouse_outbounds[2].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[2].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 4 &&
                      item.id === an_item.warehouse_outbounds[3].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[3].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 5 &&
                      item.id === an_item.warehouse_outbounds[4].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[4].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 6 &&
                      item.id === an_item.warehouse_outbounds[5].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[5].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 7 &&
                      item.id === an_item.warehouse_outbounds[6].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[6].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 8 &&
                      item.id === an_item.warehouse_outbounds[7].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[7].price | currency
                    }}
                  </tr>
                  <tr
                    v-if="
                      an_item.warehouse_outbounds.length >= 9 &&
                      item.id === an_item.warehouse_outbounds[8].outlet_id
                    "
                  >
                    {{
                      an_item.warehouse_outbounds[8].price | currency
                    }}
                  </tr>
                </td>
                <td v-if="an_item.status != 1 && an_item.status != 2">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-warning"
                    @click="confirmDelete(an_item)"
                  ></Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Dialog
      :visible.sync="deleteDialog"
      :style="{ width: '450px' }"
      header="Confirm"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span v-if="mutasi">
          Apakah kamu yakin ingin menghapus
          <b>{{ mutasi.item_name }}</b
          >?
        </span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteDialog = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteMutasi(mutasi.item_id)"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
var moment = require('moment')
import { mapState } from 'vuex'
export default {
  computed: mapState(['user', 'isAuthenticated']),
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      outlets: [],
      loading: true,
      products: null,
      expandedRows: [],
      detail: null,
      mutasi: {},
      loop: 1,
      deleteDialog: false,
      dataOutlet: [
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        },
        {
          outlet_id: null,
          qty: null,
          price: null
        }
      ]
    }
  },
  mounted() {
    this.getListOutlets()
    this.getOutlets()
    this.getAuthUser()
  },
  methods: {
    confirmDelete(mutasi) {
      this.mutasi = mutasi
      this.deleteDialog = true
    },

    getAuthUser() {
      console.info(this.user)
    },

    async getListOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        this.loading = false

        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          console.error('Gagal mendapatkan data outlet')
        }
      } catch (error) {
        this.loading = false
        console.error('Error fetching outlets:', error)
      }
    },

    async getOutletOutgoingCSV() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds/csv?doc_number=${this.$route.query.doc_number}`,
          { responseType: 'blob' }
        )

        if (response.status === 200) {
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'outletOutgoing.csv'
          link.click()
        }
      } catch (error) {
        console.error('Error fetching outlet outgoing CSV:', error)
      }
    },

    async deleteMutasi(item_id) {
      try {
        const deleteResponse = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds?doc_number=${this.$route.query.doc_number}&item_id=${item_id}`
        )
        this.deleteDialog = false

        if (deleteResponse.status === 200) {
          this.showToast(
            'success',
            'Mutasi Berhasil dihapus',
            'Mutasi berhasil dihapus',
            3000
          )

          try {
            const getResponse = await this.$http.get(
              `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutation?doc_number=${this.$route.query.doc_number}`
            )

            if (getResponse.status === 200) {
              this.detail = getResponse.data.data
            } else {
              this.$router.push('/mutation/list')
            }
          } catch (error) {
            console.error('Error fetching mutation details:', error)
            this.$router.push('/mutation/list')
          }
        } else {
          this.showToast(
            'error',
            'Gagal Hapus',
            'Delete mutasi gagal, silahkan coba lagi nanti',
            3000
          )
        }
      } catch (error) {
        this.deleteDialog = false
        console.error('Error deleting mutation:', error)
        this.showToast(
          'error',
          'Gagal Hapus',
          'Terjadi kesalahan saat menghapus mutasi',
          3000
        )
      }
    },

    async getOutlets() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutation?doc_number=${this.$route.query.doc_number}`
        )

        if (response.status === 200) {
          this.detail = response.data.data
        } else {
          console.error('Gagal mendapatkan data')
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;
  .p-progressbar-value {
    background-color: #607d8b;
  }
}
.p-datatable .p-column-filter {
  display: none;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }
  .p-paginator {
    padding: 1rem;
  }
  .p-datatable-thead > tr > th {
    text-align: left;
  }
  .p-datatable-tbody > tr > td {
    cursor: auto;
  }
  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}
/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }
  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }
  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }
  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}
.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}
@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}
.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
.orders-subtable {
  padding: 1rem;
}
.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }
  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }
  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}
input:disabled {
  color: black;
}
.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;
  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }
  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }
  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }
  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}
@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }
      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;
          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }
          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
